/**
 * 訴求エリア
 */

import { Swiper, Navigation, Pagination, Controller, EffectFade } from 'swiper';

document.querySelectorAll('.section-special').forEach(section => {
  const imageSwiper = new Swiper(section.querySelector('.special-image .swiper'), {
    modules: [EffectFade, Controller],
    allowTouchMove: true,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
  });

  const contentSwiper = new Swiper(section.querySelector('.special-content .swiper'), {
    modules: [Navigation, Pagination, Controller],
    //allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 24,
    //autoHeight: true,
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    controller: {
      control: imageSwiper,
    },
    breakpoints: {
      992: {
        spaceBetween: 40,
      }
    },
  });

  imageSwiper.controller.control = contentSwiper;
});
